/* Runde 2 (30.09.2026), Punkte 2 und 3.
   2. Stilfehler sichtbar machen: Liefert die KI (Gemini) stumm das Originalfoto zurueck (teeinblue meldet trotzdem "fertig"),
      zeigt die Seite einen Hinweis und sperrt "In den Warenkorb". Erkennung: Ergebnisbild und Originalfoto werden auf 48 x 48 Pixel
      verkleinert und verglichen; ist die mittlere Abweichung unter 10 von 255, ist es das Originalfoto. Kann der Browser die Bilder
      nicht lesen (CORS), passiert nichts. "Original, ohne Stil" hat keinen KI-Effekt und wird nie geprueft.
   3. Hinweistext im Personalisierer: der Satz zum Formatwechsel steht nur bei Produkten mit Format-Auswahl, dort mit dem
      wahren Inhalt (Foto bleibt, Ausschnitt anpassen). Nach einem Formatwechsel setzt teeinblue das Stilfeld zurueck:
      der zuletzt gewaehlte Stil wird wieder gesetzt. */
(() => {
  'use strict';
  if (window.__pmpStilfehler) return;
  window.__pmpStilfehler = true;
  if (!document.body.classList.contains('template-product')) return;
  const cfg = window.PMP_KAUFPFAD || {};
  const TEXT = (window.PMP && window.PMP.strings && window.PMP.strings.stilErr) || 'Der Stil konnte gerade nicht erstellt werden. Bitte versuche es in ein paar Minuten noch einmal.';
  const CDN = 'https://cdnx.teeinblue.com/';
  const SPERR = 'pmp-stilfehler-aktiv';

  const css = document.createElement('style');
  css.textContent =
    '.pmp-stilfehler{margin:.8rem 0;padding:.8rem 1rem;border:1.5px solid #b42318;border-radius:.6rem;background:#fff4f2;color:#7a1a10;font-size:.95rem;line-height:1.4}\n' +
    'body.' + SPERR + ' .tee-btn--atc,body.' + SPERR + ' .tee-form-atc-wrapper button,body.' + SPERR + ' .shopify-payment-button,body.' + SPERR + ' [data-add-to-cart]{opacity:.45;cursor:not-allowed}\n';
  document.head.appendChild(css);

  const meldung = document.createElement('div');
  meldung.className = 'pmp-stilfehler';
  meldung.setAttribute('role', 'alert');
  meldung.hidden = true;
  meldung.textContent = TEXT;

  const stilFeld = () => document.querySelector('select[id$="-template"]');
  const zeigen = (an) => {
    if (an) {
      const f = stilFeld();
      const ziel = f && (f.closest('.tee-field') || f.parentElement);
      if (ziel && meldung.previousElementSibling !== ziel) ziel.insertAdjacentElement('afterend', meldung);
      else if (!meldung.parentElement) { const w = document.querySelector('.tee-form-wrapper'); if (w) w.appendChild(meldung); }
    }
    meldung.hidden = !an;
    if (an) document.querySelectorAll('.pmp-wait').forEach((e) => { e.hidden = true; });
    document.body.classList.toggle(SPERR, an);
  };

  /* Sperre: Klicks auf die Kaufknoepfe und Absenden des Formulars abfangen */
  const istKauf = (el) => el && el.closest && el.closest('.tee-btn--atc, .tee-form-atc-wrapper button, .shopify-payment-button, [data-add-to-cart]');
  ['click', 'touchend'].forEach((ev) => document.addEventListener(ev, (e) => {
    if (document.body.classList.contains(SPERR) && istKauf(e.target)) { e.preventDefault(); e.stopImmediatePropagation(); meldung.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }, true));
  document.addEventListener('submit', (e) => {
    if (document.body.classList.contains(SPERR) && e.target && e.target.matches && e.target.matches('form[action*="/cart/add"], .tee-form-wrapper form')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  /* Stilwechsel oder neues Foto hebt die Sperre auf, die naechste Berechnung entscheidet neu */
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.matches && (t.matches('select[id$="-template"]') || t.matches('input[type=file]'))) zeigen(false);
  }, true);

  const url = (p) => {
    if (!p) return null;
    const m = /^(w[es]):(.+)$/.exec(p);
    return m ? CDN + m[1] + '/' + m[2] : null;
  };
  const laden = (u) => new Promise((ok, nein) => {
    const i = new Image(); i.crossOrigin = 'anonymous';
    i.onload = () => ok(i); i.onerror = () => nein(new Error('laden')); i.src = u;
  });
  const pixel = (img) => {
    const c = document.createElement('canvas'); c.width = c.height = 48;
    const x = c.getContext('2d'); x.drawImage(img, 0, 0, 48, 48);
    return x.getImageData(0, 0, 48, 48).data;
  };
  const abweichung = async (a, b) => {
    const [ia, ib] = await Promise.all([laden(a), laden(b)]);
    const pa = pixel(ia), pb = pixel(ib);
    let s = 0, n = 0;
    for (let i = 0; i < pa.length; i += 4) { s += Math.abs(pa[i] - pb[i]) + Math.abs(pa[i + 1] - pb[i + 1]) + Math.abs(pa[i + 2] - pb[i + 2]); n += 3; }
    return s / n;
  };

  const erledigt = {};
  let zuletzt = 0;
  const pruefe = async (statusUrl) => {
    let j;
    try { const r = await fetch(statusUrl, { headers: { Accept: 'application/json' } }); if (!r.ok) return; j = await r.json(); } catch (e) { return; }
    if (!j || j.status !== 2 || erledigt[j.id]) return;
    const eff = (j.effects && j.effects.effects) || [];
    if (!eff.some((x) => x && (x.type === 'image_filter' || x.provider === 'gemini'))) { erledigt[j.id] = 1; return; }
    const erg = url(j.url), orig = url(j.original);
    if (!erg || !orig) return;
    erledigt[j.id] = 1;
    try {
      const d = await abweichung(erg, orig);
      if (j.id >= zuletzt) { zuletzt = j.id; zeigen(d < 10); }
      window.__pmpStilAbw = d;
    } catch (e) { /* nicht lesbar: keine Sperre */ }
  };

  window.__pmpStilPruefe = pruefe; /* Testzugang fuer die Qualitaetssicherung */
  const gesehen = {};
  const beobachte = (name) => {
    if (!/image-filter-effects\/status/.test(name)) return;
    const k = name.split('?')[0];
    const jetzt = Date.now();
    if (gesehen[k] && jetzt - gesehen[k] < 3000) return;
    gesehen[k] = jetzt;
    setTimeout(() => pruefe(name), 600);
  };
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver((l) => l.getEntries().forEach((e) => beobachte(e.name))).observe({ type: 'resource', buffered: true });
    } catch (e) { /* alte Browser */ }
  }

  /* 3a. Hinweistext */
  const hinweisAnpassen = () => {
    document.querySelectorAll('.tee-upload-instruction').forEach((el) => {
      const t = el.textContent || '';
      if (!/Wechselst du das Format/i.test(t)) return;
      const neu = cfg.hatFormat
        ? t.replace(/Wechselst du das Format, lade dein Foto bitte neu hoch\.?/i, 'Wechselst du das Format, passe den Ausschnitt an oder lade ein anderes Foto hoch.')
        : t.replace(/\s*Wechselst du das Format, lade dein Foto bitte neu hoch\.?/i, '');
      if (neu !== t) el.textContent = neu;
    });
  };

  /* 3b. Stil nach Formatwechsel wieder setzen */
  let letzterStil = null, hatFotoSchon = false;
  const beimAendern = (e) => {
    const s = e.target;
    if (!(s && s.matches && s.matches('select[id$="-template"]'))) return;
    const o = s.options[s.selectedIndex];
    if (o && s.value && s.value !== 'null') letzterStil = o.textContent.trim();
  };
  document.addEventListener('change', beimAendern, true);
  document.addEventListener('change', (e) => { if (e.target && e.target.matches && e.target.matches('input[type=file]')) hatFotoSchon = true; }, true);
  const stilWiederSetzen = () => {
    const s = stilFeld();
    if (!s || !letzterStil || !hatFotoSchon) return;
    if (s.value && s.value !== 'null') return;
    if ([...document.querySelectorAll('button')].some((k) => k.offsetParent && /^\s*(Speichern|Save)\s*$/i.test(k.textContent || ''))) return;
    if (!document.querySelector('.tee-form-wrapper .tee-photo img')) return;
    const o = [...s.options].find((x) => x.textContent.trim() === letzterStil && x.value && x.value !== 'null');
    if (!o) return;
    s.value = o.value;
    s.dispatchEvent(new Event('input', { bubbles: true }));
    s.dispatchEvent(new Event('change', { bubbles: true }));
  };

  setInterval(() => { hinweisAnpassen(); stilWiederSetzen(); }, 800);
})();
